import RpcService from '@/core/services/Rpc/RpcService';
import RpcResponse from '@/core/services/Rpc/RpcResponse';

/**
 * DAO для производственных площадок
 */
class ProductionSitesDAO {

    /**
     * Загружает площадку по id
     */
    static async get(id: string): Promise<RpcResponse> {
        return await RpcService.makeRequest('productionSites.get', {
            id,
        });
    }

    /**
     * Загружает список площадок
     */
    static async getList(
        partnerId?: number | null,
        companyId?: number | null
    ): Promise<RpcResponse> {
        return await RpcService.makeRequest('productionSites.getList', {
            partner: partnerId ? { id: partnerId } : null,
            company: companyId ? { id: companyId } : null,
        });
    }
}

export default ProductionSitesDAO;